import { StyledCard } from "./Card.styled";

export default StyledCard;